export default {
    OLD_PASSWORD: "Старый пароль",
    NEW_PASSWORD: "Новый пароль",
    REPEAT_PASSWORD: "Повторите пароль",
    CONFIRM: "Подтвердить",
    CANCEL: "Отмена",
    OLD_PASSWORD_IS_REQUIRED: "Задайте старый пароль",
    INVALID_PASSWORD: "Неверный пароль",
    PASSWORD_CONFIRMATION_IS_INVALID: "Неверное подтверждение пароля",
    CHANGE_PASSWORD_ERROR: "Невозможно изменить пароль",
    CHANGE_PASSWORD_SUCCESS: "Пароль успешно изменён",
    ONLY_SPACES: "Пароль не может содержать только пробелы",
    ANSWER: [
        "очень слабый пароль",
        "слабый пароль",
        "пароль средней сложности",
        "сильный пароль",
        "очень сильный пароль"
    ]
};
